(function (_) {
    'use strict';

    _['MONDAY'] = 'Lunes';
    _['TUESDAY'] = 'Martes';
    _['WEDNESDAY'] = 'Miércoles';
    _['THURSDAY'] = 'Jueves';
    _['FRIDAY'] = 'Viernes';
    _['SATURDAY'] = 'Sábado';
    _['SUNDAY'] = 'Domingo';
    _['MONDAY_SHORT'] = 'L';
    _['TUESDAY_SHORT'] = 'M';
    _['WEDNESDAY_SHORT'] = 'X';
    _['THURSDAY_SHORT'] = 'J';
    _['FRIDAY_SHORT'] = 'V';
    _['SATURDAY_SHORT'] = 'S';
    _['SUNDAY_SHORT'] = 'D';
    _['CHOOSE_CALENDAR'] = 'Elige un calendario';
    _['ALL_CALENDARS'] = 'Todos los calendarios';

    _['JANUARY'] = 'Enero';
    _['FEBRUARY'] = 'Febrero';
    _['MARCH'] = 'Marzo';
    _['APRIL'] = 'Abril';
    _['MAY'] = 'Mayo';
    _['JUNE'] = 'Junio';
    _['JULY'] = 'Julio';
    _['AUGUST'] = 'Agosto';
    _['SEPTEMBER'] = 'Septiembre';
    _['OCTOBER'] = 'Octubre';
    _['NOVEMBER'] = 'Noviembre';
    _['DECEMBER'] = 'Diciembre';

    _['CALENDAR.KEY'] = 'Reservas';
    _['CALENDAR.MY_BOOKINGS'] = 'Mis reservas';
    _['MAKE_RESERVATION'] = 'Haz tu reserva';

    _['CALENDAR.DATE'] = 'Fecha';
    _['CALENDAR.DATE_PLACEHOLDER'] = 'Fecha de la reserva';
    _['CALENDAR.CANCEL_RESERVATION'] = 'Cancelar reserva';
    _['CALENDAR.INTERVAL'] = 'Hora';
    _['CALENDAR.INTERVAL_PLACEHOLDER'] = 'Selecciona una hora';
    _['CALENDAR.MAX_ATTENDANTS'] = 'Número de personas';
    _['CALENDAR.COMMENTS'] = 'Comentarios';
    _['CALENDAR.COMMENTS_PLACEHOLDER'] = 'Escribe un comentario...';
    _['CALENDAR.AVAILABLE'] = 'disponible/s';
    _['CALENDAR.EVENT_NOT_AVAILABLE'] = 'No hay espacio para hacer una reserva con el número de asistentes introducido. Quizás alguien ha hecho una reserva mientras hacía la suya.';
    _['CALENDAR.INVALID_EVENT'] = 'La hora seleccionada no es válida.';
    _['CALENDAR.EVENT_PAST'] = 'La hora seleccionado ya ha pasado, no puedes seleccionarla.';

    _['CALENDAR.BOOKING_SUCCESS_TITLE'] = 'Ha realizado su reserva correctamente';
    _['CALENDAR.BOOKING_SUCCESS_MSG'] = 'Acabas de hacer una petición de reserva. Aún tienes que recibir la confirmación. Una vez recibas la confirmación la reserva será válida y podrás disfrutar de tu reserva.';

    _['CALENDAR.NO-BOOKINGS'] = 'No hay ninguna reserva.';
    _['CALENDAR.STATUS'] = 'Estado';
    _['CALENDAR.PENDING'] = 'Pendiente';
    _['CALENDAR.ACCEPTED'] = 'Aceptada';
    _['CALENDAR.USER_DENIED'] = 'Cancelada';
    _['CALENDAR.CREATOR_DENIED'] = 'Denegada';
    _['CALENDAR.CALENDAR'] = 'Calendario';
    _['CALENDAR.ATTENDANTS'] = 'Asistentes';

    _['BOOKINGS.MENU'] = 'Mis reservas';

}(translations['es']));


// WEBPACK FOOTER //
// ./src/app/modules/booking/lang/booking-lang_es.js